import I3Detail from './I3Detail';

export default I3Detail;
